import React, { useEffect, useState } from 'react';
import { Dialog, Grid, IconButton, TextField, useMediaQuery, useTheme, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Close, SettingsInputAntenna } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FHEDivider from 'src/renderer/data/components/FHEDivider';
import { inelioSetDiagModeAction, inelioSetSlaveActuatorAction, inelioSetStageActuatorAction } from '../../../../../../../data/Products/actions';
import getMiddlewareSocketInstance from '../../../../../../../common/SocketMiddleware';
import Translator from '../../../../../../../../../../../translator';

const moment = require('moment');

const SLAVE_EVENT = 'getInelioSlaveMeasures';
const STAGE_EVENT = 'getInelioStageMeasures';
const INIT_STATE = new Array(15).fill({ time: '', measure: '' });

const isCorrectSlave = (props, payload, slave) => {
    return props.fheCenter_mac === payload.fheCenter_mac && props.product_identifier === payload.product_identifier && slave === payload.slave;
};

const isCorrectStage = (props, payload, code) => {
    return props.fheCenter_mac === payload.fheCenter_mac && props.product_identifier === payload.product_identifier && code === payload.code;
};
function LiveDataModal({ onClose, classes, code, ...props }) {
    const [slaveData, setSlaveData] = useState(INIT_STATE);
    const [stageData, setStageData] = useState(INIT_STATE);
    const slave = code.slice(0, 2);
    const stage = code.slice(3, 5);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        getMiddlewareSocketInstance()
            .on(SLAVE_EVENT, handleSlaveEvent)
            .on(STAGE_EVENT, handleStageEvent);
        return () => {
            getMiddlewareSocketInstance() &&
                getMiddlewareSocketInstance()
                    .removeListener(SLAVE_EVENT, handleSlaveEvent)
                    .removeListener(STAGE_EVENT, handleStageEvent);
        };
    }, []);

    const handleSlaveEvent = payload => {
        if (isCorrectSlave(props, payload, slave)) {
            setSlaveData(data => {
                const arr = [...data];
                arr.shift();
                return [...arr, { measure: payload.measures, time: moment().format('HH:mm:ss') }];
            });
        }
    };
    const handleStageEvent = payload => {
        if (isCorrectStage(props, payload, code)) {
            setStageData(data => {
                const arr = [...data];
                arr.shift();
                return [...arr, { measure: payload.measures, time: moment().format('HH:mm:ss') }];
            });
        }
    };

    return (
        <Dialog open onClose={onClose} maxWidth={false} fullScreen={fullScreen}>
            <Grid container className={classes.container}>
                <Grid container item xs={12}>
                    <Grid className={classes.title} container alignContent="center" item xs={11}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <SettingsInputAntenna className={classes.icon} />
                        </div>
                        {Translator.translate('general.liveData')}
                    </Grid>
                    <Grid container alignItems="center" justify="center" item xs={1}>
                        <IconButton aria-label="close" className={classes.closeIcon} size="medium" onClick={onClose}>
                            <Close fontSize="inherit" />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container alignItems="center" justify="space-between" item xs={12}>
                    <Grid item className={classes.subtitle}>
                        Esclave: {slave}
                    </Grid>
                </Grid>
                <Grid container item xs={12} className={classes.row}>
                    {slaveData.map(({ time, measure }, i) => (
                        <Grid item xs={12} key={i}>
                            {`${time} - ${measure ? JSON.stringify(measure) : ''}`}
                        </Grid>
                    ))}
                </Grid>
                <FHEDivider />
                <Grid container alignItems="center" justify="space-between" item xs={12}>
                    <Grid item className={classes.subtitle}>
                        Etage: {stage}
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    {stageData.map(({ time, measure }, i) => (
                        <Grid item xs={12} key={i}>
                            {`${time} - ${measure ? JSON.stringify(measure) : ''}`}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Dialog>
    );
}

const styles = theme => ({
    container: {
        width: '90vw',
        padding: 18,
    },
    title: {
        color: theme.palette.primary.main,
        fontSize: 34,
        fontWeight: 400,
        marginBottom: 12,
    },
    icon: {
        fontSize: '2rem',
        marginRight: 8,
    },
    subtitle: {
        color: theme.palette.primary.main,
        fontSize: 18,
    },
});

LiveDataModal.propTypes = {
    fheCenter_mac: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    product_identifier: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
};
LiveDataModal.defaultProps = {};

export default withRouter(
    connect(
        null,
        dispatch => bindActionCreators({ inelioSetDiagModeAction, inelioSetSlaveActuatorAction, inelioSetStageActuatorAction }, dispatch),
    )(withStyles(styles, { withTheme: true })(LiveDataModal)),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/components/LiveDataModal.js